import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApiService } from '../../../shared/services/api.service';
import {
  ImageCroppedEvent,
  ImageCropperComponent,
} from 'ngx-image-cropper';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import bsCustomFileInput from 'bs-custom-file-input';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-modal-student-profile-avatar',
    templateUrl: './modal-student-profile-avatar.component.html',
    styleUrls: ['./modal-student-profile-avatar.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule, FontAwesomeModule, ImageCropperComponent],
})
export class ModalStudentProfileAvatarComponent implements OnInit {
  // Icons
  faSpinner = faSpinner;

  public isProcessing = false;

  public data: any;

  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl = '';
  croppedBlob: Blob | null | undefined = null;

  fileName = '';

  file = '';

  account = {
    id: '',
  };

  constructor(
    public activeModal: NgbActiveModal,
    public api: ApiService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    bsCustomFileInput.init();

    this.account = this.data;
  }

  /**
   * Event handler when file input changes (updated)
   */
  fileChangeEvent(event: Event): void {
    this.imageChangedEvent = event;

    // Search for file name when input file changes
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.fileName = target.files[0].name;
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
      event.objectUrl ?? ''
    );
    this.croppedBlob = event.blob;
  }

  imageLoaded(image: HTMLImageElement) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  /**
   * Save avatar image
   *
   * @constructor
   */
  Save() {
    this.isProcessing = true;

    if (this.croppedBlob && this.fileName) {
      const fd = new FormData();
      const file = new File([this.croppedBlob], this.fileName, {
        type: this.croppedBlob.type,
      });
      fd.append('file', file);

      // Upload the file
      const API_URL =
        this.api.getApiUrl() + '/account/' + this.account.id + '/avatar';
      const headers = this.api.getUploadHeaders();
      fetch(API_URL, { method: 'PUT', headers: headers, body: fd })
        .then((res) => {
          this.isProcessing = false;
          if (res.status == 200) {
            this.activeModal.close(true);
          } else {
            // Some error
          }
        })
        .catch((error) => {
          this.isProcessing = false;
        });
    }
  }
}
